import { Button, Grid, Tooltip, Typography, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../css/global.css"; // Importa el archivo global.css
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import { TablePaginate } from "../../../layout/Datagrid/TablePaginate";
import { Add } from "@mui/icons-material";
import getColumnsMontosAF from "../../../layout/Columns/ColumnsMontosAF";
import { mostrarDatosListaMontosAF } from "../../../services/PpafeservicesAF";

export interface fechaOrNull {
    fecha: string;
}

export default function MontosAF() {
    const TITULO = "Aportaciones Federales Montos";
    const navigate = useNavigate();
    const [dataLoading, setDataLoading] = useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [perPage, setPerPage] = React.useState(25);
    const [responseData, setResponseData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const openSolicitud = () => {
        const url = `/admin/aportaciones/federales/solicitudreporteaf`;
        navigate(url);
    };
    const handleVerClick = (id: string, link: string) => {
        navigate("/" + link + "/alta/" + id);
    };

    const columns = getColumnsMontosAF({ handleVerClick, urlOrigen: '/usuarios/listado', navigate });

    const ObtenerDatos = () => {
        const tipo = "aportaciones"; // Aquí puedes cambiarlo dinámicamente
        const origen = "federales"; // También puedes pasarlo según la pantalla
        mostrarDatosListaMontosAF(tipo, origen, setLoading, setResponseData, setError);
    };

    useEffect(() => {
        ObtenerDatos();
    }, []);

    return (
        <Grid container sx={{}}>
            <Grid sx={{}} item xs={12}>
                <BreadcrumbBar
                    links={[
                        { texto: "Inicio", link: "/admin" },
                        // { texto: "Configuración", link: "" },
                    ]}
                    Titulo={TITULO}
                />
            </Grid>
            <Grid container>
                <Grid item width={"100%"}>
                    <Typography
                        variant="h5"
                        component="div"
                        sx={{
                            flexGrow: 1,
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "left",
                        }}
                    >
                        {TITULO}
                    </Typography>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} md={1} lg={2} mt={1}>
                    <Tooltip title="Agregar Solicitud">
                        <Button
                            onClick={() => openSolicitud()}
                            sx={{ marginLeft: "5px", textTransform: "capitalize" }}
                            variant="contained"
                            size="small"
                        >
                            <Add /> Agregar
                        </Button>
                    </Tooltip>
                </Grid>

                <Grid
                    sx={{
                        justifyContent: "center",
                        paddingTop: "1px",
                        height: "8px",
                        display: "",
                    }}
                    item
                    xs={12}
                    md={12}
                    mt={2}
                ></Grid>
            </Grid>

            <TablePaginate
                rowsInfo={responseData}
                columns={columns}
                Mostrar={false}
                loading={dataLoading}
            />
        </Grid >
    );
}
